import { useState, useEffect, useCallback } from "react";
/**
 * Hook to fetch and manage subscription and token balance
 */
export function useSubscription(options) {
    const { apiConfig } = options;
    const [subscription, setSubscription] = useState(null);
    const [tokenBalance, setTokenBalance] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchSubscription = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);
            const accessToken = await apiConfig.getAccessToken();
            const response = await fetch(`${apiConfig.baseUrl}/billing/subscription`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch subscription: ${response.status}`);
            }
            const data = (await response.json());
            setSubscription(data.subscription);
            setTokenBalance(data.tokenBalance);
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
        }
        finally {
            setIsLoading(false);
        }
    }, [apiConfig]);
    useEffect(() => {
        fetchSubscription();
    }, [fetchSubscription]);
    return {
        subscription,
        tokenBalance,
        isLoading,
        error,
        refresh: fetchSubscription,
    };
}
//# sourceMappingURL=use-subscription.js.map